import React from 'react';
import styled from 'styled-components';
import Surface from '../components/Surface';
import { Heading, Label, Accent } from '../components/Typography';
import ScrollReveal, { StaggerContainer, StaggerItem } from '../components/ScrollReveal';

const PageWrapper = styled(Surface).attrs({ tone: 'base' })`
  padding: 4rem 2rem;

  @media (max-width: 768px) {
    padding: 2.5rem 1.5rem;
  }
`;

const Inner = styled.div`
  max-width: 900px;
  margin: 0 auto;
`;

const PageLabel = styled(Label)`
  display: block;
  color: #a0412d;
  margin-bottom: 0.75rem;
`;

const PageTitle = styled(Heading)`
  font-size: clamp(2rem, 4vw, 2.75rem);
  font-weight: 800;
  margin-bottom: 2.5rem;
`;


const SkillCategory = styled(Surface).attrs({ tone: 'raised' })`
  padding: 1.75rem;
  border-radius: 1.25rem;
  box-shadow: 0 20px 40px rgba(56, 49, 45, 0.05);
`;

const CategoryLabel = styled(Label)`
  display: block;
  color: #a0412d;
  margin-bottom: 0.6rem;
`;

const CategoryTitle = styled.h3`
  font-family: 'Epilogue', sans-serif;
  font-size: 1.125rem;
  font-weight: 700;
  color: #38312d;
  margin-bottom: 1rem;
`;

const ChipList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`;

const Chip = styled.span`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 0.8125rem;
  font-weight: 500;
  background-color: #fbf3e4;
  color: #605b50;
  padding: 0.35rem 0.85rem;
  border-radius: 9999px;
`;

const Skills = () => (
  <PageWrapper>
    <Inner>
      <ScrollReveal variant="up">
        <PageLabel>Capabilities</PageLabel>
        <PageTitle>Skills &amp; <Accent>Training.</Accent></PageTitle>
      </ScrollReveal>

      <StaggerContainer
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, 1fr)',
          gap: '1.25rem',
          marginTop: '1.5rem',
        }}
        stagger={0.1}
      >
        <StaggerItem><SkillCategory>
          <CategoryLabel>Performance</CategoryLabel>
          <CategoryTitle>Acting Training</CategoryTitle>
          <ChipList>
            <Chip>LBF Acting for Camera 2023</Chip>
            <Chip>Showbiz Christchurch Musical Theatre 2022</Chip>
            <Chip>Joseph &amp; The Amazing Technicolour Dreamcoat 2024</Chip>
            <Chip>Shrek Jr 2025</Chip>
          </ChipList>
        </SkillCategory></StaggerItem>

        <StaggerItem><SkillCategory>
          <CategoryLabel>Voice</CategoryLabel>
          <CategoryTitle>Singing</CategoryTitle>
          <ChipList>
            <Chip>SOLE Music Academy 2024</Chip>
            <Chip>Formal Vocal Tuition since age 6 - Soprano 1</Chip>
            <Chip>Christchurch Competitions Society (Vocal) - multiple awards</Chip>
            <Chip>Children's Special Choir 2023</Chip>
          </ChipList>
        </SkillCategory></StaggerItem>

        <StaggerItem><SkillCategory>
          <CategoryLabel>Physical</CategoryLabel>
          <CategoryTitle>Sports</CategoryTitle>
          <ChipList>
            <Chip>Netball 5yrs</Chip>
            <Chip>Swimming 5yrs</Chip>
            <Chip>Touch Rugby 6yrs</Chip>
            <Chip>Gymnastics &amp; Trampolining 2yrs</Chip>
          </ChipList>
        </SkillCategory></StaggerItem>

        <StaggerItem><SkillCategory>
          <CategoryLabel>Culture &amp; Screen</CategoryLabel>
          <CategoryTitle>Other</CategoryTitle>
          <ChipList>
            <Chip>Kapa Haka 3yrs</Chip>
            <Chip>Genesis TVC Hero 2022-present</Chip>
          </ChipList>
        </SkillCategory></StaggerItem>
      </StaggerContainer>
    </Inner>
  </PageWrapper>
);

export default Skills;
